(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var $alert = $('.pgn-wrapper .alert');
var showPeriod = 5000;

if ($alert.length) {
    $alert.each(function(i) {
        i++;
        setTimeout(function() {
            $(this).remove();
        }.bind(this), showPeriod * i);
    });
}

},{}],2:[function(require,module,exports){
'use strict';

module.exports = function(app) {

    app.formLabels = function() {
        var formGroup = $('.form-group');

        formGroup.each(function() {
            var label = $(this).children('label');
            var input = $(this).children('input, select, textarea');

            if (input && input.val() && input.length && input.val().length) {
                label.addClass('fade');
            }
        });
    };

    return app;
};

},{}],3:[function(require,module,exports){
'use strict';

module.exports = function(app) {
    var formChange = require('./change')(app);

    formChange.formLabels();
    $('[data-init-plugin="select2"]').on('select2-close', function () {
        if (!$(this).attr('multiple')) {
            setTimeout(function() {
                $('.select2-container-active').removeClass('select2-container-active');
                $(':focus').blur();

                formChange.formLabels();
            }, 1);
        }
    });

    return app;
};

},{"./change":2}],4:[function(require,module,exports){
'use strict';

module.exports = function(app) {

    app.notificationCheckAll = function(button) {
        var checks = $(button).parents('.js-notifications-form').find('input[type="checkbox"]');

        checks.prop('checked', true);
    };

    return app;
};

},{}],5:[function(require,module,exports){
'use strict';

module.exports = function(app) {

    app.notificationCountRefresh = function(form) {
        var count = $(form).find('.js-notification').length;
        var countBubble = $('.notification-list .bubble');

        if (count > 0) {
            countBubble.show().html(count);
        } else {
            countBubble.hide();
        }
    };

    return app;
};

},{}],6:[function(require,module,exports){
'use strict';

module.exports = function(app) {

    app.notificationLoad = function(path) {
        var wrapper = $('.notification-panel');

        // Preloader
        wrapper.html($('.js-preloader-wrap').find('.notification-footer').clone());

        $.ajax({
            url: path
        }).done(function(data) {
            wrapper.html(data);
        });
    };

    return app;
};

},{}],7:[function(require,module,exports){
'use strict';

module.exports = function(app) {
    var notifications = require('./counter-change')(app);

    $(document).off('submit.ajax-form');
    $(document).on('submit.ajax-form', '.ajax-form', function (e) {
        e.preventDefault();

        var form          = $(this);
        var formContainer = form.parent();

        $.ajax({
            type    : 'POST',
            url     : form.attr('action'),
            data    : form.serialize(),
            dataType: 'json',
            encode  : true
        }).complete(function (data) {
            formContainer.html(data.responseText);

            var form = $(data.responseText);
            if (form.hasClass('js-notifications-form')) {
                notifications.notificationCountRefresh(form);
            }
        });
    });

    return app;
};

},{"./counter-change":5}],8:[function(require,module,exports){
'use strict';

// TODO: Refactor.
module.exports = function (app) {
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        if ('history' !== e.target.getAttribute('aria-controls')) {
            return;
        }

        $.ajax({
            url: '/order/order-history/list/' + window.app.values.order.id
        }).done(function(data) {
            $('#history').html(data);
        });
    });

    return app;
};

},{}],9:[function(require,module,exports){
/**
 * Player functionality
 */

module.exports = function(player) {
    'use strict';

    var icon_play = 'fa-play';
    var icon_stop = 'fa-stop';
    var button = '.js-play';
    var canPlay = false;

    // On click use virtual dom and play
    $(document).off('click', button);
    $(document).on('click', button, function(){

        // Default stop class
        icon_stop = $(this).data('toggle') || icon_stop;
        player.datafileName = $(this).data('src').split('\\').pop().split('/').pop();
        player.sourceName = player.src.split('\\').pop().split('/').pop();

        // If we trying to play nex track - force to play it
        if (decodeURIComponent(player.datafileName) !== decodeURIComponent(player.sourceName)) {
            player.src = $(this).data('src');
            player.volume = 1;

            startPlayer($(this));
        }
        else {
            // If already playing stop and change icons
            if (!player.paused) {
                stopPlayer();
            } else {
                if (false === canPlay) {
                    $('body').pgNotification({message: window.app.trans.audio.error_message, type: 'danger'}).show();
                    stopPlayer();
                } else {
                    startPlayer($(this));
                }
            }
        }
    });

    // On ended change icon
    player.addEventListener("ended", function () {
        stopPlayer();
    });

    // On error - display message
    player.addEventListener('error', function (data) {
        $('body').pgNotification({message: window.app.trans.audio.error_message, type: 'danger'}).show();
        canPlay = false;
        stopPlayer();
    });

    // Can we play the audio?
    player.addEventListener('oncanplaythrough', function () {
        canPlay = true;
    });
    player.addEventListener('canplay', function () {
        canPlay = true;
    });

    function startPlayer(target) {
        stopPlayer();
        target
            .toggleClass(icon_play, false)
            .toggleClass(icon_stop, true)
        ;
        player.play();
    }

    function stopPlayer() {
        $(button)
            .toggleClass(icon_play, true)
            .toggleClass(icon_stop, false)
        ;
        player.pause();
        player.currentTime = 0;
    }

    return player;
};

},{}],10:[function(require,module,exports){
'use strict';

$('select[data-init-plugin="cs-select"]').on('change', function() {
    var selectName = $(this).attr('name');
    var form = $('[data-cs-name="' + selectName + '"]').closest('form');

    setTimeout(function() {
        form.submit();
    }, 50);
});

},{}],11:[function(require,module,exports){
'use strict';

$(document).off('init.select2');
$(document).on('init.select2', function() {
    $.fn.select2.defaults.set('width', '100%');

    $.fn.select2 && $('[data-init-plugin="select2"]').each(function() {
        $(this).select2({
            minimumResultsForSearch: ($(this).attr('data-disable-search') == 'true' ? -1 : 1)
        }).on('select2-opening', function() {
            $.fn.scrollbar && $('.select2-results').scrollbar({
                ignoreMobile: false
            })
        });
    });
});

},{}],12:[function(require,module,exports){
'use strict';

module.exports = function(app) {

    app.showPassword = function (button) {
        $(button).siblings('input').attr('type', 'text');
    };

    app.hidePassword = function (button) {
        $(button).siblings('input').attr('type', 'password');
    };

    return app;
};

},{}],13:[function(require,module,exports){
var app = window.app || {};

// Global libraries
require('../lib/player/main')(document.createElement('audio'));

// --Basic
require('../lib/alerts/close-timer');

require('../lib/select2/init');
$(document).trigger('init.select2');

require('../lib/select-dropdown-init');
app = require('../lib/show-password')(app);

// --Notifications
app = require('../lib/notifications/load')(app);
app = require('../lib/notifications/check-all')(app);
app = require('../lib/notifications/submit')(app);

// --Form labels
app = require('../lib/form-labels/change')(app);
app = require('../lib/form-labels/load')(app);

// --Order history
app = require('../lib/order-history/initialize')(app);

window.app = app;

$(document).on('change', 'input:file', function() {
    'use strict';

    var input = $(this);
    var path = input.val().split('\\').pop();
    var pathInput = input.siblings('.input-group').find('.path-input');

    pathInput.val(path);
});

},{"../lib/alerts/close-timer":1,"../lib/form-labels/change":2,"../lib/form-labels/load":3,"../lib/notifications/check-all":4,"../lib/notifications/load":6,"../lib/notifications/submit":7,"../lib/order-history/initialize":8,"../lib/player/main":9,"../lib/select-dropdown-init":10,"../lib/select2/init":11,"../lib/show-password":12}]},{},[13])

